import { Provider } from '@angular/core';
import { provideRoutes } from 'routing-util';
import { CartFeatureRoutesConfig, defaultCartFeatureRoutesConfig } from './CartFeatureRoutesConfig';

export function provideCartFeatureRoutes(config?: Partial<CartFeatureRoutesConfig>): Provider {
  const useConfig = { ...defaultCartFeatureRoutesConfig, ...config };
  return [
    provideRoutes([
      {
        path: useConfig.path,
        loadChildren: () => import('./routes/routes').then((m) => m.routes),
      },
    ]),
  ];
}
